import { render, staticRenderFns } from "./ClientListing.vue?vue&type=template&id=346de806"
import script from "./ClientListing.vue?vue&type=script&lang=js"
export * from "./ClientListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports